export const UPDATED_CART_ITEM = 'UPDATED_CART_ITEM';

export function updatedCartItem() {
    return {
        type: UPDATED_CART_ITEM,
        payload: {}
    };
}
